module.exports = __webpack_public_path__ + "img/soptim-logo.21c1e165.png";